import Styled from 'styled-components';

export const Color = Styled.div`
  color: ${(props) => props.color};
  white-space: nowrap;
`;
